/**
 * Pagination constants for report listing
 */

export const PAGINATION = {
  /** Number of reports displayed per page */
  PAGE_SIZE: 10,
} as const;
